import dayjs from 'dayjs'
import { sleep } from '@enuygun/frontend-components'

import { savePreviousCategoryBeforeSubmit } from 'utils/searchForm'

import { logHomepageSearchFormSubmit, resolveHomepageSearchRef } from './searchFormSubmitTracking'
import type { SearchFormSubmitOptions } from './submitOptions'

export const carRentalHandleSubmit = async (form, options: SearchFormSubmitOptions = {}) => {
  const { index = null, delay = 0, url = 'https://www.enuygun.com', variant, productCategory } = options
  const refValue = resolveHomepageSearchRef(variant)

  if (index !== null) savePreviousCategoryBeforeSubmit(String(index))
  logHomepageSearchFormSubmit({ variant, productCategory: productCategory || 'arac-kiralama' })

  const hasDropOffLocation = form?.hasDropOffLocation
  const pickUpTime = form.pickUpTime
  const dropOffTime = form.dropOffTime
  const pickUpDate = dayjs(form.pickUpDate).format('YYYY-MM-DD')

  let dropOffDate = dayjs(form.dropOffDate).format('YYYY-MM-DD')
  if (form.month) {
    const monthOffset = Number.parseInt(form.month, 10)
    const calculatedDate = dayjs(form.pickUpDate).add(monthOffset, 'month')
    dropOffDate = calculatedDate.format('YYYY-MM-DD')
  }

  const pickUpLocation = form?.pickUpLocation?.slug
  const dropOffLocation = hasDropOffLocation ? form?.dropOffLocation?.slug : pickUpLocation

  const params = new URLSearchParams({
    pickUpTime,
    dropOffTime,
    dropOffDate,
    pickUpDate,
    dropOffLocation,
    pickUpLocation,
    driverAge: form?.driverAge,
  })

  // Aylık kiralama parametresini ekle
  if (form.month) {
    params.append('month', form.month)
  }

  const redirectURL = `${url}/arac-kiralama/arama/?${params}&ref=${refValue}`

  await sleep(delay)

  globalThis.location.href = `${redirectURL}`
}
